import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Component from '../constants/Component';
import { getLanguageFromPath } from '../utils/routeTranslator';

const MainLayout = () => {
    const location = useLocation();
    const { i18n } = useTranslation();
    const pathLang = getLanguageFromPath(location.pathname) || i18n.language;
    const isArabic = pathLang === 'ar';

    const [navBarBg, setnavBarBg] = useState('navbar-nav');
    
    useEffect(() => {
        // Update navbar background based on pathname
        const isHomePage = location.pathname === `/${pathLang}` || location.pathname === `/${pathLang}/`;
        if (isHomePage) {
            setnavBarBg('navbar-navOnthorPAge');
        } else {
            setnavBarBg('navbar-nav');
        }
    }, [location.pathname, pathLang]);

    return (
        <>
            <div className="loading__page">
                <Component.NavBar navbarColor={navBarBg} />
                <div style={{ position: 'relative' }}>
                    <Component.Whatsapp />
                    <Outlet />
                </div>
            </div>
            <Component.Footer />
        </>
    );
};

export default MainLayout;

